import { useState } from 'react';

import { INewFile } from '../types/interfaces/new-file';
import { uploadFilesUtils } from '../utils/upload-files-utils';
import { IAppFile } from '../types/interfaces/app-file';

export function useFileList(files: IAppFile[]) {
  const [fileIdsToDelete, setFileIdsToDelete] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState<INewFile[]>([]);

  async function onUploadFiles(files: FileList, uploadPreview = false) {
    const uploadedFiles = (await uploadFilesUtils(files, uploadPreview)).filter(
      Boolean,
    );

    setFilesToUpload((prev) => [...prev, ...uploadedFiles] as any);
  }

  function onDeleteFile(id: number | string) {
    if (typeof id === 'string') {
      setFileIdsToDelete((prev) => [...prev, id]);
    } else {
      setFilesToUpload((prev) => prev.filter((f) => f.id !== id));
    }
  }

  function getResultFiles(): (INewFile | IAppFile)[] {
    return [
      ...files.filter((f) => !fileIdsToDelete.some((fid) => fid === f.id)),
      ...filesToUpload,
    ];
  }

  function resetFilesState() {
    setFilesToUpload([]);
    setFileIdsToDelete([]);
  }

  return {
    fileIdsToDelete,
    filesToUpload,
    resultFiles: getResultFiles(),
    onDeleteFile,
    onUploadFiles,
    resetFilesState,
  };
}
